import React, { useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import axios from "axios";
import homeVideoBg from "../images/homeVideos.jpg";
import { Constant } from "../helper/Constants";

const HomeVideos = () => {
  const [allYoutube, setAllYoutube] = useState([]);
  const [homeYoutube, setHomeYoutube] = useState({});

  const allVideos = async () => {
    try {
      const resp = await axios.get(Constant.getUrls.getAllYoutTubeSlider);
      setAllYoutube(resp?.data?.data);

      const response = await axios.get(Constant.getUrls.getAllYoutube);
      setHomeYoutube(response?.data?.data);
    } catch (error) {
      console.log(error);
      setAllYoutube([]); // fallback handled in render
    }
  };

  useEffect(() => {
    allVideos();
  }, []);

  const swiperParams = {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1200: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    },
  };

  return (
    <div style={{ width: "100%", fontFamily: "Arial, sans-serif" }}>
      {/* ====================== FIRST SECTION ====================== */}
      <div
        style={{
          backgroundImage: `url(${homeVideoBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "60px 20px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "30px",
        }}
      >
        {/* LEFT CONTENT */}
        <div
          style={{
            maxWidth: "520px",
            color: "white",
            flex: "1 1 320px",
          }}
        >
          <h1
            style={{
              fontSize: "clamp(24px, 4vw, 38px)",
              fontWeight: "900",
              lineHeight: "1.2",
            }}
          >
            THE MESMERIZING EFFECT OF{" "}
            <span style={{ color: "#ff6f6f" }}>ABACUS TRAINING</span>
          </h1>

          <p
            style={{
              marginTop: "15px",
              fontSize: "15px",
              lineHeight: "22px",
              color: "#ff6f6f",
            }}
          >
            VASA-ABACUS training makes children confident. They perform mental
            math with ease. Their speed and accuracy are great.
          </p>
        </div>

        {/* VIDEO */}
        <div
          style={{
            width: "100%",
            maxWidth: "420px",
            aspectRatio: "16 / 9",
            borderRadius: "10px",
            overflow: "hidden",
            border: "3px solid white",
            flex: "1 1 320px",
          }}
        >
          <iframe
            width="100%"
            height="100%"
            src={
              "https://www.youtube.com/embed/" + homeYoutube?.home_youtube_id
            }
            title="YouTube video"
            style={{ border: "none" }}
            allowFullScreen
          />
        </div>
      </div>

      {/* ====================== SECOND SECTION ====================== */}
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <h1
          style={{
            fontSize: "clamp(22px, 4vw, 32px)",
            fontWeight: "900",
            lineHeight: "1.3",
          }}
        >
          WATCH LIGHTNING FAST MENTAL MATH CALCULATIONS AT <br />
          <span style={{ color: "#ff6f6f" }}>VASA-ABACUS ACADEMY</span>
        </h1>

        <p
          style={{
            color: "#444",
            maxWidth: "800px",
            margin: "20px auto",
            fontSize: "15px",
            lineHeight: "22px",
          }}
        >
          Our students perform mental math with unparalleled speed and accuracy.
          Witness their impressive skills as they outpace calculators!
        </p>

        {/* ================= SWIPER ================= */}
        <div
          style={{
            marginTop: "40px",
            maxWidth: "1100px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Swiper {...swiperParams}>
            {allYoutube.map((vid, index) => {
              // ✅ normalize video id (object OR string)
              const videoId = typeof vid === "string" ? vid : vid?.youtube_id;

              if (!videoId) return null;

              return (
                <div key={videoId || index}>
                  <div
                    style={{
                      width: "100%",
                      maxWidth: "320px",
                      aspectRatio: "16 / 9",
                      borderRadius: "10px",
                      overflow: "hidden",
                      border: "2px solid #ddd",
                      margin: "auto",
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title="Student Video"
                      style={{ border: "none" }}
                      allowFullScreen
                    />
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default HomeVideos;

// import React, { useState, useEffect } from "react";
// import Swiper from "react-id-swiper";
// import "swiper/css/swiper.css";
// import axios from "axios";
// import homeVideoBg from "../images/homeVideos.jpg";
// import { Constant } from "../helper/Constants";

// const HomeVideos = () => {
//   const [allYoutube, setAllYoutube] = useState([]);

//   const allVideos = async () => {
//     try {
//       axios.get(Constant.getUrls.getAllYoutTubeSlider).then((resp) => {
//         console.log(resp);
//         setAllYoutube(resp.data.data);
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     allVideos();
//   }, []);

//   const swiperParams = {
//     slidesPerView: 3,
//     spaceBetween: 20,
//     loop: true,
//     autoplay: {
//       delay: 2000,
//       disableOnInteraction: false,
//     },
//     breakpoints: {
//       1200: { slidesPerView: 3 },
//       768: { slidesPerView: 2 },
//       0: { slidesPerView: 1 },
//     },
//   };

//   return (
//     <div style={{ width: "100%", fontFamily: "Arial, sans-serif" }}>
//       {/* ====================== FIRST SECTION ====================== */}
//       <div
//         style={{
//           backgroundImage: `url(${homeVideoBg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           padding: "60px 20px",
//           display: "flex",
//           flexWrap: "wrap",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: "30px",
//         }}
//       >
//         {/* LEFT CONTENT */}
//         <div
//           style={{
//             maxWidth: "520px",
//             color: "white",
//             flex: "1 1 320px",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: "clamp(24px, 4vw, 38px)",
//               fontWeight: "900",
//               lineHeight: "1.2",
//             }}
//           >
//             THE MESMERIZING EFFECT OF{" "}
//             <span style={{ color: "#ff6f6f" }}>ABACUS TRAINING</span>
//           </h1>

//           <p
//             style={{
//               marginTop: "15px",
//               fontSize: "15px",
//               lineHeight: "22px",
//               color: "#ff6f6f",
//             }}
//           >
//             VASA-ABACUS training makes children confident. They perform mental
//             math with ease. Their speed and accuracy are great.
//           </p>
//         </div>

//         {/* VIDEO */}
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "420px",
//             aspectRatio: "16 / 9",
//             borderRadius: "10px",
//             overflow: "hidden",
//             border: "3px solid white",
//             flex: "1 1 320px",
//           }}
//         >
//           <iframe
//             width="100%"
//             height="100%"
//             src="https://www.youtube.com/embed/XyjPhppVIDA"
//             title="YouTube video"
//             style={{ border: "none" }}
//             allowFullScreen
//           />
//         </div>
//       </div>

//       {/* ====================== SECOND SECTION ====================== */}
//       <div style={{ textAlign: "center", padding: "60px 20px" }}>
//         <h1
//           style={{
//             fontSize: "clamp(22px, 4vw, 32px)",
//             fontWeight: "900",
//             lineHeight: "1.3",
//           }}
//         >
//           WATCH LIGHTNING FAST MENTAL MATH CALCULATIONS AT <br />
//           <span style={{ color: "#ff6f6f" }}>VASA-ABACUS ACADEMY</span>
//         </h1>

//         <p
//           style={{
//             color: "#444",
//             maxWidth: "800px",
//             margin: "20px auto",
//             fontSize: "15px",
//             lineHeight: "22px",
//           }}
//         >
//           Our students perform mental math with unparalleled speed and accuracy.
//           Witness their impressive skills as they outpace calculators!
//         </p>

//         {/* ================= SWIPER ================= */}
//         <div
//           style={{
//             marginTop: "40px",
//             maxWidth: "1100px",
//             marginLeft: "auto",
//             marginRight: "auto",
//           }}
//         >
//           <Swiper {...swiperParams}>
//             {(Array.isArray(allYoutube) && allYoutube.length > 0
//               ? allYoutube
//               : ["eyLsbv8E4Kg", "rUFav9gtxWM", "MgH-nFpUYvY"]
//             ).map((vid) => (
//               <div key={vid}>
//                 <div
//                   style={{
//                     width: "100%",
//                     maxWidth: "320px",
//                     aspectRatio: "16 / 9",
//                     borderRadius: "10px",
//                     overflow: "hidden",
//                     border: "2px solid #ddd",
//                     margin: "auto",
//                   }}
//                 >
//                   <iframe
//                     width="100%"
//                     height="100%"
//                     src={`https://www.youtube.com/embed/${vid?.youtube_id}`}
//                     title="Student Video"
//                     style={{ border: "none" }}
//                     allowFullScreen
//                   />
//                 </div>
//               </div>
//             ))}
//           </Swiper>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomeVideos;
